module.exports = __webpack_public_path__ + "static/img/48030.74cc121.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/48030.jpg
// module id = t9h4
// module chunks = 1